import { render, staticRenderFns } from "./Lot.vue?vue&type=template&id=0a8e0cac&"
import script from "./Lot.vue?vue&type=script&lang=ts&"
export * from "./Lot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports